import React from "react";
import { Empty } from "antd/lib";
import i18nStore from "@Helpers/i18nStore";

const EmptyCM = () => {
  const t = i18nStore?.getGlobalT();
  const description = t ? t("CM.content_no_data") : "No data";

  return <Empty description={description} />;
};

export default EmptyCM;
